<form
  [formGroup]="form"
  (ngSubmit)="onSubmitRegistrationCategoryFilter()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="
            isCollapsedRegCategoryOptions ? 'false' : 'true'
          "
          (click)="
            isCollapsedRegCategoryOptions = !isCollapsedRegCategoryOptions
          "
          aria-controls="registrationCategoryOptions"
        >
          <span class="fs-3">{{
            'general.registrationCategoryOptions' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedRegCategoryOptions
                ? 'fa-chevron-down'
                : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsedRegCategoryOptions"
      class="card-body"
      id="registrationCategoryOptions"
    >
      <fieldset class="mb-4">
        <legend class="form-label" id="regDescLabel">{{
          'general.description' | translate
        }}</legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-0"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="regDescLabel flag-nl-0"
                formControlName="description_nl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="regDescLabel flag-en-0"
                formControlName="description_en"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-0"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="regDescLabel flag-fr-0"
                formControlName="description_fr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="regDescLabel flag-de-0"
                formControlName="description_de"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <div class="row">
        <div class="col-sm" *ngIf="availableLanguages['nl']">
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_nl.dirty &&
              form.controls.description_nl.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'general.value' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div class="col-sm" *ngIf="availableLanguages['en']">
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_en.dirty &&
              form.controls.description_en.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'general.value' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div class="col-sm" *ngIf="availableLanguages['fr']">
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_fr.dirty &&
              form.controls.description_fr.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'general.value' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div class="col-sm" *ngIf="availableLanguages['de']">
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_de.dirty &&
              form.controls.description_de.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'general.value' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
      </div>

      <div class="card-table">
        <table class="table border-bottom table-light table-sm">
          <thead>
            <tr>
              <th scope="col" id="catOptionLabel">{{
                'general.optionId' | translate
              }}</th>
              <th
                scope="col"
                *ngIf="availableLanguages['nl']"
                id="catNameNlLabel"
              >
                {{ 'general.name' | translate }}
                <span
                  role="img"
                  class="flag flag-nl ms-2"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['en']"
                id="catNameEnLabel"
              >
                {{ 'general.name' | translate }}
                <span
                  role="img"
                  class="flag flag-en ms-2"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['fr']"
                id="catNameFrLabel"
              >
                {{ 'general.name' | translate }}
                <span
                  role="img"
                  class="flag flag-fr ms-2"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['de']"
                id="catNameDeLabel"
              >
                {{ 'general.name' | translate }}
                <span
                  role="img"
                  class="flag flag-de ms-2"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span>
              </th>
              <th scope="col" id="catValuelabel">{{
                'general.categoryValue' | translate
              }}</th>
              <th scope="col" colspan="2" id="catGroupNameLabel">
                {{ 'general.groupName' | translate }}
              </th>
            </tr>
          </thead>

          <tbody
            formArrayName="options"
            *ngFor="
              let options of regCategoryOptionOptionsFormArray.controls;
              let i = index
            "
          >
            <tr [formGroupName]="i">
              <td>
                <input
                  type="number"
                  min="1"
                  step="1"
                  class="form-control"
                  aria-labelledby="catOptionLabel"
                  formControlName="optionId"
                  readonly
                />
              </td>
              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  formControlName="name_nl"
                  aria-labelledby="catNameNlLabel"
                  aria-describedby="catNameNlError"
                  [attr.aria-invalid]="
                    options.controls.name_nl.dirty &&
                    options.controls.name_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catNameNlError"
                  *ngIf="
                    options.controls.name_nl.dirty &&
                    options.controls.name_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  formControlName="name_en"
                  aria-labelledby="catNameEnLabel"
                  aria-describedby="catNameEnError"
                  [attr.aria-invalid]="
                    options.controls.name_en.dirty &&
                    options.controls.name_en.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catNameEnError"
                  *ngIf="
                    options.controls.name_en.dirty &&
                    options.controls.name_en.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  formControlName="name_fr"
                  aria-labelledby="catNameFrLabel"
                  aria-describedby="catNameFrError"
                  [attr.aria-invalid]="
                    options.controls.name_fr.dirty &&
                    options.controls.name_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catNameFrError"
                  *ngIf="
                    options.controls.name_fr.dirty &&
                    options.controls.name_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  formControlName="name_de"
                  aria-labelledby="catNameDeLabel"
                  aria-describedby="catNameDeError"
                  [attr.aria-invalid]="
                    options.controls.name_de.dirty &&
                    options.controls.name_de.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catNameDeError"
                  *ngIf="
                    options.controls.name_de.dirty &&
                    options.controls.name_de.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td>
                <select
                  class="form-select"
                  aria-labelledby="catValuelabel"
                  formControlName="categoryValue"
                  *ngIf="hasExtendedCategories"
                >
                  <option value="0">
                    0 -
                    {{ 'category0desc' | getCategoryDescription | async }}
                  </option>
                  <option value="1">
                    1 -
                    {{ 'category1desc' | getCategoryDescription | async }}
                  </option>
                  <option value="2">
                    2 -
                    {{ 'category2desc' | getCategoryDescription | async }}
                  </option>
                  <option value="3">
                    3 -
                    {{ 'category3desc' | getCategoryDescription | async }}
                  </option>
                  <option value="4">
                    4 -
                    {{ 'category4desc' | getCategoryDescription | async }}
                  </option>
                  <option value="5">
                    5 -
                    {{ 'category5desc' | getCategoryDescription | async }}
                  </option>
                  <option value="6">
                    6 -
                    {{ 'category6desc' | getCategoryDescription | async }}
                  </option>
                  <option value="7">
                    7 -
                    {{ 'category7desc' | getCategoryDescription | async }}
                  </option>
                  <option value="8">
                    8 -
                    {{ 'category8desc' | getCategoryDescription | async }}
                  </option>
                  <option value="9">
                    9 -
                    {{ 'category9desc' | getCategoryDescription | async }}
                  </option>
                </select>
                <select
                  class="form-select"
                  aria-labelledby="catValuelabel"
                  aria-describedby="catValueError"
                  formControlName="categoryValue"
                  *ngIf="!hasExtendedCategories"
                >
                  <option value="0">
                    0 -
                    {{ 'category0desc' | getCategoryDescription | async }}
                  </option>
                  <option value="1">
                    1 -
                    {{ 'category1desc' | getCategoryDescription | async }}
                  </option>
                  <option value="2">
                    2 -
                    {{ 'category2desc' | getCategoryDescription | async }}
                  </option>
                  <option value="3">
                    3 -
                    {{ 'category3desc' | getCategoryDescription | async }}
                  </option>
                </select>

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catValueError"
                  *ngIf="
                    options.controls.categoryValue.dirty &&
                    options.controls.categoryValue.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>

              <td>
                <input
                  type="text"
                  class="form-control"
                  aria-labelledby="catGroupNameLabel"
                  aria-describedby="catGroupNameError"
                  formControlName="group"
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="catGroupNameError"
                  *ngIf="
                    options.controls.group.dirty &&
                    options.controls.group.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>

              <td>
                <button
                  type="button"
                  class="btn btn-ghost-secondary"
                  (click)="deleteRegCatOptionOptionRow(i)"
                  [canSee]="[accessRights.ConfigurationOptions_delete]"
                >
                  <i
                    role="img"
                    class="fa fa-trash-alt"
                    attr.aria-label="{{ 'general.delete' | translate }}"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-start">
        <button
          class="btn btn-soft-primary btn-sm"
          type="button"
          (click)="addRegCatOptionOptionRow()"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.addRow' | translate }}
        </button>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
